/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const SkillBasedQueueBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useSkillBasedQueueUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="SkillBasedQueue" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default SkillBasedQueueBreadcrumbs;
